import React from 'react';
import {
  Box,
} from '@mui/material';

const FloatFooter = (props: any) => {
  const { children } = props;

  return (
    <Box className="float-footer">
      {children}
    </Box>
  );
}

export default FloatFooter;
